import { ApolloError } from "@apollo/client";
import { Box } from "@mui/material";
import { Layout } from "components/Layout";
import { usePageTitle } from "hooks/usePageTitle";
import { useNavigate, useRouteError } from "react-router-dom";
import { detectSandboxOff } from "utils/sandboxOff";

import { ErrorDisplay } from "../components/ErrorDisplay";
import { SandboxOffPage } from "./SandboxOff";

export function Oops() {
  const error = useRouteError();
  const sandboxOff = detectSandboxOff(error);
  usePageTitle(sandboxOff.isSandboxOff ? "Sandbox is turned off" : "Something went wrong");
  const apolloError = error as ApolloError;
  const navigate = useNavigate();
  // Show traces only if user isStaff or non-prod environments

  if (sandboxOff.isSandboxOff) {
    // Standalone, without Layout: its nav queries the same API that is down.
    return <SandboxOffPage env={sandboxOff.env} error={error} />;
  }

  if (!(error instanceof Error)) throw error; // really uncaught because it's not even an error

  const goBack = () => {
    localStorage.removeItem("preLoginPath");
    navigate(-1);
  };

  return (
    <Layout>
      <Box mx="144px">
        <ErrorDisplay error={error} apolloError={apolloError} onAction={goBack} />
      </Box>
    </Layout>
  );
}
